import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const QUICK_LINKS = [
  { label: "Mission", href: "#why" },
  { label: "Who we help", href: "#who-we-help" },
  { label: "Ways we help", href: "#ways-we-help" },
  { label: "Learning path", href: "#programs" },
  { label: "Membership", href: "#membership" },
  { label: "FAQ", href: "#faq" },
];

const LEGAL_LINKS = [
  { label: "Privacy policy", to: "/privacy-policy", testid: "footer-privacy-link" },
  { label: "Terms of service", to: "/terms-of-service", testid: "footer-terms-link" },
  { label: "Cookie preferences", to: "/cookie-preferences", testid: "footer-cookies-link" },
];

export const SiteFooter = () => {
  const scrollTo = (e, href) => {
    e.preventDefault();
    if (window.location.pathname !== "/") {
      window.location.href = "/" + href;
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer data-testid="site-footer" className="bg-background">
      <div className="mx-auto w-full max-w-[1280px] px-5 sm:px-8">
        <div className="hairline" />
        <div className="py-[50px] lg:pt-20 lg:pb-[60px]">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-6">
              <img
                src="https://customer-assets-39nsmqrw.emergentagent.net/job_pond-education-hub/artifacts/0b0oeg8t_logo%20%285%29.webp"
                alt="Pond & Aquaculture Resource Centre"
                data-testid="footer-logo-image"
                className="h-12 sm:h-14 w-auto"
              />
              <p className="mt-5 text-sm sm:text-base leading-relaxed text-foreground/60 max-w-[48ch]">
                Independent education, training, and consulting for pond
                aquaculture in Alberta. We help you understand the water before
                you work with it.
              </p>
              <a
                href="mailto:info@pondresourcecentre.com"
                data-testid="footer-email-link"
                className="nav-underline mt-8 inline-flex items-center gap-1.5 text-sm text-foreground/80 hover:text-foreground whitespace-nowrap"
              >
                <Mail className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                info@pondresourcecentre.com
              </a>
            </div>

            <div className="lg:col-span-3">
              <p className="font-mono-meta text-[10px] text-foreground/45">Quick Links</p>
              <ul className="mt-5 space-y-3">
                {QUICK_LINKS.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => scrollTo(e, link.href)}
                      className="nav-underline text-sm text-foreground/70 hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-3">
              <p className="font-mono-meta text-[10px] text-foreground/45">Legal</p>
              <ul className="mt-5 space-y-3">
                {LEGAL_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      data-testid={link.testid}
                      className="nav-underline text-sm text-foreground/70 hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

          </div>

          <div className="mt-[54px] lg:mt-16 pt-6 hairline flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="font-mono-meta text-[10px] text-foreground/45">
              © {new Date().getFullYear()} Pond & Aquaculture Resource Centre
            </p>
            <p data-testid="footer-tagline-text" className="font-mono-meta text-[10px] text-foreground/45">
              Independent · Education-first
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
